/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PusherAuthDto } from '../models/PusherAuthDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PusherService {
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static pusherControllerAuthenticateV1(
        requestBody: PusherAuthDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/pusher/auth',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
